import React, { useEffect } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { WifiOff, Wifi } from 'lucide-react';
import { useOfflineStatus } from '@/hooks/useOfflineStatus';
import { useToast } from '@/hooks/use-toast';

export const OfflineIndicator: React.FC = () => {
  const { isOnline, wasOffline } = useOfflineStatus();
  const { toast } = useToast();

  useEffect(() => {
    if (!isOnline) {
      toast({
        title: "You're offline",
        description: "You can still view cached job details",
        variant: "default",
      });
    } else if (wasOffline) {
      toast({
        title: "Back online",
        description: "Your connection has been restored",
        variant: "default",
      });
    }
  }, [isOnline, wasOffline, toast]);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-16 left-0 right-0 z-40 px-3 sm:px-4 lg:px-6">
      <Alert className="bg-warning/10 border-warning">
        <WifiOff className="h-4 w-4 text-warning" />
        <AlertDescription className="text-warning-foreground">
          You're currently offline. You can still view cached job details.
        </AlertDescription>
      </Alert>
    </div>
  );
};
